import axios from '@/utils/axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'
import {get,has} from 'lodash'

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  isAuthorized: false,
  role: "user"
};

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => state.user !== null,
  isAuthorized: state => state.isAuthorized,
  role: state => state.role,
  
};

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, {token, remember}) {
    state.token = token;
    state.isAuthorized = true;
    Cookies.set('token', token, {expires: remember ? 365 : null})
  },

  [types.FETCH_USER_SUCCESS](state, {user}) {
    state.isAuthorized = true;
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null;
    state.isAuthorized = false;
    Cookies.remove('token');
  },

  [types.LOGOUT](state) {
    state.user = null;
    state.token = null;
    state.isAuthorized = false;
    state.role = 'user';
    Cookies.remove('token');
  },

  [types.UPDATE_USER](state, {user}) {
    state.user = user;
    const role = get(user,"role");
    if(role) {
      state.role = role;
    }
  },
};

// actions
export const actions = {

  saveToken({commit, dispatch}, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser({commit}) {
    try {
      const {data} = await axios.get('/admin/user');
      commit(types.FETCH_USER_SUCCESS, {user: data})
      commit(types.UPDATE_USER, {user: data})
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser({commit}, payload) {
    commit(types.UPDATE_USER, payload)
  },

    async logout({commit})
  {
      try {
          await axios.get('/admin/logout');
      }
      catch (e)
      {
          console.error("Logout", e);
      }
      commit(types.LOGOUT)
  }

};
